import { Button, Card, Col, Row, Select, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";

const AdminRoleFilter = ({
    handleSearch = () => { }
}) => {
    const { t } = useTranslation();

    return (
        <Card style={{ border: "1px solid #EAECF0", borderRadius: "8px" }}>
            <FormAntd
                onFinish={handleSearch}
            >
                <FormItem shouldUpdate={(prev, curv) => {
                    return false
                }}>
                    {({ getFieldValue, setFieldValue, resetFields }) => {
                        return (
                            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                                <Row gutter={[24, 0]}>
                                    <Col span={12}>
                                        <FormInput
                                            name="roleName"
                                            label={t('userList.label.role')}
                                            placeholder={t('userList.label.role')}
                                            size="large"
                                        />
                                    </Col>

                                    <Col span={12} style={{ paddingRight: 0 }}>
                                        <FormSelect
                                            name="statusFlag"
                                            label={t('translation.status')}
                                            placeholder={t('translation.status')}
                                            size="large"
                                            options={[
                                                { value: 'INACTIVE', label: t("response_company.label.inactive") },
                                                { value: 'ACTIVE', label: t("response_company.label.active") },
                                            ]}
                                            allowClear
                                        />
                                    </Col>

                                </Row>
                                <Row gutter={24} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                    <Button
                                        type="default"
                                        onClick={() => { resetFields() }}
                                        style={{ borderRadius: "8px" }} size="large"
                                    >
                                        {t("common.cancel").toUpperCase()}
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                        size="large"
                                    >
                                        {t("common.search").toUpperCase()}
                                    </Button>
                                </Row>
                            </Space>
                        )
                    }}
                </FormItem>
            </FormAntd>
        </Card>
    )
}

export default AdminRoleFilter;